import * as React from "react";
import styled, { css } from "styled-components";
import Player from "./Types/Player";
import ConnectionIndicator from "./ConnectionIndicator";
import Button from "./Button";
import Spectator from "./Types/Spectator";

interface Props {
  players: Player[];
  activePlayerName?: string;
  className?: string;
  isSpectating?: boolean;
  spectating?: string;
  spectators?: Spectator[];
  onSpectatorChange?: (name: string) => void;
}

const PlayerOrder = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  text-align: left;
  padding: 1rem;
  background: black;
`;

const StyledConnectionIndicator = styled(ConnectionIndicator)``;

const StyledPlayer = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  font-size: 2rem;

  &:before {
    content: " ";
    width: 0.5em;
    height: 0.5em;
    display: inline-block;
    margin-right: 0.2em;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.3em 0 0.3em 0.5em;
    border-color: transparent transparent transparent beige;
    opacity: 0;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      &:before {
        opacity: 1;
      }
    `}

  ${StyledConnectionIndicator} {
    margin-left: 10px;
    opacity: 0.8;
  }
`;

const PaddedContainer = styled.div`
  padding: 5px;
`;

const SpectatorContainer = styled.div<{ fixedSpectator: boolean }>`
  padding: 5px;
  font-size: ${({ fixedSpectator }) => (fixedSpectator ? `20px;` : `15px;`)};
`;

const FlexContainer = styled.div<{ fixedSpectator: boolean }>`
  display: flex;
  align-items: center;
  ${({ fixedSpectator }) => fixedSpectator && `outline: solid white;`}
`;

const getPlayerInfo = (
  activePlayerName: string | undefined,
  p: Player,
  i: number
) => (
  <StyledPlayer isActive={activePlayerName === p.name} key={i + p.name}>
    {`${p.name}`}
    <StyledConnectionIndicator isConnected={p.isConnected} />
  </StyledPlayer>
);

const Players = ({
  players,
  activePlayerName,
  className,
  isSpectating = false,
  spectating,
  spectators = [],
  onSpectatorChange,
}: Props) => (
  <PlayerOrder className={className}>
    {players.map((p, i) => {
      return isSpectating ? (
        <PaddedContainer>
          <FlexContainer fixedSpectator={spectating === p.name}>
            <Button
              isDark
              isSmall
              onClick={() => onSpectatorChange && onSpectatorChange(p.name)}
            >
              <PaddedContainer>
                {getPlayerInfo(activePlayerName, p, i)}
              </PaddedContainer>
            </Button>
            {(spectating === p.name ||
              (!spectating && activePlayerName === p.name)) && (
              <SpectatorContainer fixedSpectator={spectating === p.name}>
                👀
              </SpectatorContainer>
            )}
          </FlexContainer>
        </PaddedContainer>
      ) : (
        <>{getPlayerInfo(activePlayerName, p, i)}</>
      );
    })}
    {!isSpectating &&
      activePlayerName &&
      spectators.length > 0 &&
      `You have ${spectators.length} spectator${
        spectators.length > 1 ? "s" : ""
      }`}
  </PlayerOrder>
);

export default Players;
